module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "P_Heading_1",
    attrs: {
      "id": "auto_bookmark_toc_1"
    }
  }, [_c('span', [_vm._v("Above and Beyond")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Norm-NoIndent"
  }, [_vm._v("By Andrew Grey")]), _vm._v(" "), _c('p', {
    staticClass: "P_Norm-NoIndent"
  }, [_vm._v("Sequel to "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Over and Back")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Norm-NoIndent"
  }, [_vm._v("Bronco’s Boys: Book Six")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("When Salvatore Adruccio finished his time in the military, he moved on to a life of good friends, cold drinks, and hot men. His job as a bouncer at Bronco’s is fun and drama-free, at least until sexy but secretive server Elliot Hastings catches his eye.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("On the run and in possession of evidence that could expose his stepfather for the dangerous and powerful criminal he is, Elliot doesn’t want to draw anyone else into his troubles. But when a thug catches up to him and Salvatore fends him off, he decides Elliot needs his help, even if he won’t admit it. Attraction quickly heats into passion, but Elliot is wary of commitment when he might have to drop everything and run at any moment. The only way they can be together in all the ways they want is to take out the threat posed by Elliot’s stepfather and his underworld ties.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("And Salvatore intends to do just that.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34aefee5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0002.vue
// module id = 60
// module chunks = 0